"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const uuid_1 = require("uuid");
const functions_1 = require("../nevada-shared/functions");
const SharedTypes = __importStar(require("../nevada-shared/types"));
const initialState = {
    inputRows: [
        {
            id: (0, uuid_1.v4)(),
            referenceGenesysNo: "178571-1",
            testGenesysNo: "178567-1",
            errorMessage: []
        }
    ],
    running: false,
    runningSize: 3,
    showResults: false,
    systemTestRows: [],
    systemsInQueue: []
};
function reducer(
// biome-ignore lint: -
state = initialState, action) {
    switch (action.type) {
        case "system-compare/ADD-TEST-ROW": {
            return Object.assign(Object.assign({}, state), { inputRows: [
                    ...state.inputRows,
                    {
                        id: (0, uuid_1.v4)(),
                        referenceGenesysNo: "",
                        testGenesysNo: "",
                        errorMessage: []
                    }
                ] });
        }
        case "system-compare/DELETE-TEST-ROW": {
            return Object.assign(Object.assign({}, state), { inputRows: state.inputRows
                    .slice(0, action.index)
                    .concat(state.inputRows.slice(action.index + 1)) });
        }
        case "system-compare/IMPORT-SYSTEMS": {
            const regex = /^[DSG]/i; // Match the first letter if it's 'D', 'S', or 'G'
            return Object.assign(Object.assign({}, state), { inputRows: action.systemsToimport.map((t) => ({
                    id: (0, uuid_1.v4)(),
                    referenceGenesysNo: t[0].replace(regex, ""),
                    testGenesysNo: t[1].replace(regex, ""),
                    errorMessage: []
                })) });
        }
        case "system-compare/SET-TEST-GENESYS-NO": {
            return Object.assign(Object.assign({}, state), { inputRows: state.inputRows.map((r, ix) => ix === action.index ? Object.assign(Object.assign({}, r), { testGenesysNo: action.text }) : r) });
        }
        case "system-compare/SET-REFERENCE-GENESYS-NO": {
            return Object.assign(Object.assign({}, state), { inputRows: state.inputRows.map((r, ix) => ix === action.index ? Object.assign(Object.assign({}, r), { referenceGenesysNo: action.text }) : r) });
        }
        case "system-compare/RUN-TEST": {
            const inputRows = state.inputRows.map(testGenesysNo);
            if (inputRows.some((x) => x.errorMessage.length)) {
                return Object.assign(Object.assign({}, state), { inputRows });
            }
            const systemTestRows = inputRows.map(createSystemRowInfo);
            const runningBatch = systemTestRows
                .map((x) => x.id)
                .slice(0, state.runningSize);
            const systemsInQueue = systemTestRows
                .map((x) => x.id)
                .filter((x) => !runningBatch.includes(x));
            const updatedSystemStatus = setSystemStatus(systemTestRows, new Map(runningBatch.map((x) => [x, SharedTypes.Status.Idle])));
            return Object.assign(Object.assign({}, state), { inputRows, running: true, showResults: true, systemsInQueue: systemsInQueue, systemTestRows: updatedSystemStatus });
        }
        case "system-compare/SET-RUNNING-SIZE": {
            return Object.assign(Object.assign({}, state), { runningSize: action.size });
        }
        case "system-compare/TOGGLE-NODE": {
            const systemIndex = state.systemTestRows.findIndex((s) => s.id === action.testId);
            const system = state.systemTestRows[systemIndex];
            const nodeIndex = state.systemTestRows[systemIndex].result.nodes.findIndex((n) => action.path[0] === n.id);
            const node = state.systemTestRows[systemIndex].result.nodes[nodeIndex];
            const updatedNode = (0, functions_1.toggleNode)(node, action.path, 0);
            const updatedSystem = Object.assign(Object.assign({}, system), { result: {
                    type: "result",
                    warnings: system.result.warnings,
                    nodes: system.result.nodes
                        .slice(0, nodeIndex)
                        .concat(updatedNode)
                        .concat(system.result.nodes.slice(nodeIndex + 1))
                } });
            return Object.assign(Object.assign({}, state), { systemTestRows: state.systemTestRows
                    .slice(0, systemIndex)
                    .concat(updatedSystem)
                    .concat(state.systemTestRows.slice(systemIndex + 1)) });
        }
        case "system-compare/UPDATE-TEST-SYSTEM": {
            const index = state.systemTestRows.findIndex((s) => s.id === action.systemTestRow.id);
            let testSystems = state.systemTestRows
                .slice(0, index)
                .concat(action.systemTestRow)
                .concat(state.systemTestRows.slice(index + 1));
            const systemsInQueue = [...state.systemsInQueue];
            if (action.systemTestRow.status === SharedTypes.Status.Complete &&
                state.systemsInQueue.length > 0) {
                console.log("here");
                const nextSystemId = systemsInQueue.shift();
                testSystems = setSystemStatus(testSystems, new Map([nextSystemId].map((x) => [x, SharedTypes.Status.Idle])));
                console.log(nextSystemId, testSystems);
            }
            const running = !testSystems.every((t) => t.status === SharedTypes.Status.Complete);
            return Object.assign(Object.assign({}, state), { running: running, systemsInQueue: systemsInQueue, systemTestRows: testSystems });
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
function testGenesysNo(inputRow) {
    const regEx = new RegExp(/^([DSG]{1})?[0-9]+?-[0-9]+?$/, "i");
    const errorMessages = [];
    if (!regEx.test(inputRow.referenceGenesysNo)) {
        errorMessages.push("Invalid GenesysNo Format for reference system");
    }
    if (!regEx.test(inputRow.testGenesysNo)) {
        errorMessages.push("Invalid GenesysNo Format for test system");
    }
    return Object.assign(Object.assign({}, inputRow), { errorMessage: errorMessages });
}
function createSystemRowInfo(inputRow) {
    const referenceSplit = inputRow.referenceGenesysNo
        .trim()
        // .replace(regEx, "")
        .split("-");
    const testSplit = inputRow.testGenesysNo.trim().split("-");
    const referenceFileNo = Number.parseInt(referenceSplit[0], 10);
    const referenceRevNo = Number.parseInt(referenceSplit[1], 10);
    const testFileNo = Number.parseInt(testSplit[0], 10);
    const testRevNo = Number.parseInt(testSplit[1], 10);
    return {
        id: inputRow.id,
        name: "",
        expanded: false,
        systemType: "",
        referenceNo: referenceFileNo,
        referenceRev: referenceRevNo,
        testNo: testFileNo,
        testRev: testRevNo,
        status: SharedTypes.Status.Waiting,
        systemRowIsOk: false,
        result: undefined
    };
}
function setSystemStatus(systemsToTest, systemStatusMap) {
    return systemsToTest.map((x) => {
        if (systemStatusMap.has(x.id)) {
            return Object.assign(Object.assign({}, x), { status: systemStatusMap.get(x.id) });
        }
        return x;
    });
}
//# sourceMappingURL=reducer.js.map